module.exports = __webpack_public_path__ + "assets/img/Spinner-1s-88px.68213807.gif";